import type { FC } from 'react';
import { Card, Col, Flex, Progress, Row, Typography } from 'antd';
import type { OperatorCardViewModel } from '../../ScorecardPage.types';

const { Text, Title } = Typography;

export interface OperatorScoreCardProps {
  operator: OperatorCardViewModel;
}

export const OperatorScoreCard: FC<OperatorScoreCardProps> = ({ operator }) => {
  return (
    <Card
      className="om-section-card scorecard-operator-card"
      styles={{ body: { padding: 20 } }}
    >
      <Flex vertical gap={14}>
        <div>
          <Title level={5} style={{ margin: 0 }}>
            {operator.name}
          </Title>
          <Text type="secondary" className="scorecard-operator-card__summary">
            {operator.summary}
          </Text>
        </div>

        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Text type="secondary" className="ds-card-label">
              {operator.responseLabel}
            </Text>
            <div className="scorecard-operator-card__metric">
              {operator.responseValue}
            </div>
          </Col>
          <Col span={12}>
            <Text type="secondary" className="ds-card-label">
              {operator.uptimeLabel}
            </Text>
            <div className="scorecard-operator-card__metric">
              {operator.uptimeValue}
            </div>
          </Col>
          <Col span={12}>
            <Text type="secondary" className="ds-card-label">
              {operator.sitesLabel}
            </Text>
            <div className="scorecard-operator-card__metric">
              {operator.sitesValue}
            </div>
          </Col>
          <Col span={12}>
            <Text type="secondary" className="ds-card-label">
              {operator.penaltiesLabel}
            </Text>
            <div className="scorecard-operator-card__metric">
              {operator.penaltiesValue}
            </div>
          </Col>
        </Row>

        <div>
          <Flex
            justify="space-between"
            align="center"
            style={{ marginBottom: 6 }}
          >
            <Text type="secondary" className="ds-card-label">
              {operator.performanceLabel}
            </Text>
            <Text className="scorecard-operator-card__band">
              {operator.performanceBandLabel}
            </Text>
          </Flex>
          <Progress
            percent={operator.performancePercent}
            showInfo={false}
            strokeColor={operator.performanceStroke}
            trailColor="#e8eef8"
            size={{ height: 8 }}
          />
        </div>
      </Flex>
    </Card>
  );
};
